<template lang="pug">
  ev-dialog(
    :title="title"
    v-bind="$attrs"
    v-on="$listeners"
    hide-actions
  )
    template(v-slot:content="{ close }")
      div.pt-2
        api-form(
          v-model="instance"
          :method="method"
          :fields="fields"
          :initial="initial"
          :error-callback="(data) => formErrorCallback(data, close)"
          :success-callback="(data) => formSuccessCallback(data, close)"
          :serialize-data="serializeFormData"
          :generic-field-attrs="genericFieldAttrs"
        )
          template(v-slot:save-btn="{ attrs, loading, disabled, handleSubmit, save, invalid }")
            v-card-actions.pb-0.px-0
              v-btn.mr-1(
                v-bind="extendCloseBtnAttrs"
                @click="close"
              ) {{ extendCloseBtnAttrs['btn-text'] || DEFAULT_BTNS_TEXT[BTNS_TYPES.close] }}
              v-btn(
                v-bind="{ ...attrs, ...extendConfirmBtnAttrs }"
                :disabled="disabled || invalid"
                :loading="loading"
              ) {{ extendConfirmBtnAttrs['btn-text'] || DEFAULT_BTNS_TEXT[BTNS_TYPES.send] }}
</template>

<script>
import EvDialog from '../EvDialog.vue';

const BTNS_TYPES = {
  close: 1,
  send: 2,
};

const DEFAULT_BTNS_TEXT = {
  [BTNS_TYPES.close]: 'Отмена',
  [BTNS_TYPES.send]: 'Отправить',
};

export default {
  components: {
    EvDialog,
  },
  props: {
    formValue: { type: Object, default: () => ({}) },
    initial: { type: Object, default: () => ({}) },
    method: { type: Function, required: true },
    fields: { type: Array, default: () => [] },
    title: { type: String, default: 'Форма подтверждения' },
    errorCallback: { type: Function, default: () => null },
    successCallback: { type: Function, default: () => null },
    serializeFormData: { type: Function, default: (data) => data },
    genericFieldAttrs: { type: Object, default: () => ({}) },
    closeBtnAttrs: { type: Object, default: () => ({}) },
    confirmBtnAttrs: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      formData: this.formValue,
      DEFAULT_BTNS_TEXT,
      BTNS_TYPES,
    };
  },
  computed: {
    instance: {
      get() {
        return this.formData;
      },
      set(value) {
        this.formData = value;
        this.$emit('input', value);
      },
    },
    defaultBtnAttrs() {
      const { dark } = this.$vuetify.theme;
      return {
        [BTNS_TYPES.close]: {
          height: 48,
          class: 'flex-1 rounded-12',
          outlined: true,
          color: 'redesignPrimary',
        },
        [BTNS_TYPES.send]: {
          height: 48,
          class: 'flex-1 rounded-12',
          color: 'redesignPrimary',
          dark: !dark,
        },
      };
    },
    extendCloseBtnAttrs() {
      const { defaultBtnAttrs, closeBtnAttrs } = this;
      return {
        ...defaultBtnAttrs[BTNS_TYPES.close],
        ...closeBtnAttrs,
      };
    },
    extendConfirmBtnAttrs() {
      const { defaultBtnAttrs, confirmBtnAttrs } = this;
      return {
        ...defaultBtnAttrs[BTNS_TYPES.send],
        ...confirmBtnAttrs,
      };
    },
  },
  methods: {
    formSuccessCallback(data, close) {
      this.successCallback(data);
      close();
    },
    formErrorCallback(error, close) {
      this.errorCallback(error, close);
    },
  },
};
</script>
